import { atom } from 'recoil';
import { ATOMS_KEYS } from '../atom-keys';

export const reinitializeCalendar = atom<number>({
	key: ATOMS_KEYS.REINITIALIZECALENDAR,
	default: 0,
});
